// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Gz7Y","header":"ReportDetails_header__1Vtyv","title":"ReportDetails_title__2ObJ-","left":"ReportDetails_left__3pfYI"};